import React, { useState } from 'react';
import './TermsModal.css';

const TermsModal = ({ onAccept }) => {
  const [checked, setChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    // Force accept terms to prevent getting stuck
    if (checked && !isSubmitting) {
      setIsSubmitting(true);
      onAccept();
    }
  };

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal-content">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="terms-modal-close"
          title="Close (accept terms)"
        >
          ×
        </button>

        <h2 className="terms-modal-title">Updated Terms & Community Rules</h2>
        <div className="terms-modal-divider" />
        <p className="terms-modal-text">
          Our <a href="/terms" target="_blank" rel="noopener noreferrer" className="terms-modal-link">Terms of Service</a>, <a href="/privacy" target="_blank" rel="noopener noreferrer" className="terms-modal-link">Privacy Policy</a>, and <a href="/community-rules" target="_blank" rel="noopener noreferrer" className="terms-modal-link">Community Rules</a> have changed. Please review and accept the latest version to continue using The Orbital Ledger.
        </p>
        <div className="terms-modal-checkbox-wrapper">
          <label className="terms-modal-label">
            <input
              type="checkbox"
              id="terms-acceptance"
              checked={checked}
              onChange={e => setChecked(e.target.checked)}
              className="terms-modal-checkbox"
            />
            <span style={{ textAlign: 'left' }}>I have read and agree to the updated Terms of Service, Privacy Policy, and Community Rules.</span>
          </label>
        </div>
        <button
          className="terms-modal-button"
          disabled={!checked || isSubmitting}
          onClick={() => {
            if (!isSubmitting) {
              setIsSubmitting(true);
              onAccept();
            }
          }}
        >
          {isSubmitting ? 'Accepting...' : 'Accept & Continue'}
        </button>
      </div>
    </div>
  );
};

export default TermsModal;
